/**
 * Глобальные dialog-хелперы (ES-модуль, бандлится через Mix).
 *
 * Заменяет public/js/modal-helper.js (удалён в этом коммите):
 *   - window.showInputModal      — input-диалог (native <dialog>)
 *   - window.showSelectModal     — select-диалог (native <dialog>)
 *   - window.showAdmConfirmation — admin-style confirmation (native <dialog>)
 *   - window.showLargeModal/closeLargeModal — для модалок file-manager и каталога
 *
 * window.showConfirmation / confirmAction / confirmDelete — в ./confirmation.js
 * (Alpine + native <dialog>, без зависимости от Bootstrap).
 *
 * Все диалоги используют initDialogEnhancements (resources/js/dialog-utils.js)
 * для backdrop/Esc-обработки.
 */

import './confirmation.js';

window.showInputModal = function (options) {
    return new Promise((resolve) => {
        const modalId = 'input-modal-' + Date.now();
        const modalHtml = `
            <dialog id="${modalId}" class="adm_notifolder_vidget adm_notifolder_vidget_dialog"
                    data-close-on-backdrop="true" data-close-on-escape="true" data-backdrop="default">
                <span class="xt_close noselect" data-cancel></span>
                <div class="adm_notifolder_vidget_wrap">
                    <div class="adm_notifolder_vidget_caption"></div>
                    <div class="adm_notifolder_vidget_field">
                        <input type="text" id="${modalId}-input" />
                    </div>
                    <div class="adm_notifolder_vidget_submit">
                        <button class="xt_button xt_button_gray" data-cancel></button>
                        <button class="xt_button" data-confirm></button>
                    </div>
                </div>
            </dialog>
        `;

        document.body.insertAdjacentHTML('beforeend', modalHtml);
        const modal = document.getElementById(modalId);
        const input = document.getElementById(modalId + '-input');

        // Безопасная установка содержимого (textContent / placeholder / value)
        modal.querySelector('.adm_notifolder_vidget_caption').textContent = options.title || '';
        input.placeholder = options.placeholder || '';
        input.value = options.defaultValue || '';
        modal.querySelector('.xt_button_gray').textContent = options.cancelText || 'Cancel';
        modal.querySelector('button[data-confirm]').textContent = options.confirmText || 'OK';

        const closeAndResolve = (value) => {
            if (typeof window.closeDialog === 'function') {
                window.closeDialog(modal);
                setTimeout(() => modal.remove(), 250);
            } else {
                modal.close();
                modal.remove();
            }
            resolve(value);
        };

        modal.querySelectorAll('[data-confirm]').forEach(el => {
            el.addEventListener('click', () => closeAndResolve(input.value.trim() || null));
        });
        modal.querySelectorAll('[data-cancel]').forEach(el => {
            el.addEventListener('click', () => closeAndResolve(null));
        });
        input.addEventListener('keypress', e => {
            if (e.key === 'Enter') closeAndResolve(input.value.trim() || null);
        });
        modal.addEventListener('close', () => {
            if (modal.parentNode) modal.remove();
            resolve(null);
        }, { once: true });

        if (typeof window.openDialog === 'function') {
            window.openDialog(modal);
        } else {
            modal.showModal();
        }
        input.focus();
    });
};

window.showSelectModal = function (options) {
    return new Promise((resolve) => {
        const modalId = 'select-modal-' + Date.now();

        const modalHtml = `
            <dialog id="${modalId}" class="adm_notifolder_vidget adm_notifolder_vidget_dialog"
                    data-close-on-backdrop="true" data-close-on-escape="true" data-backdrop="default">
                <span class="xt_close noselect" data-cancel></span>
                <div class="adm_notifolder_vidget_wrap">
                    <div class="adm_notifolder_vidget_caption"></div>
                    <div class="adm_notifolder_vidget_field" data-select-field>
                        <div class="adm_notifolder_vidget_selector" data-selector></div>
                        <div class="adm_notifolder_vidget_selector_items" style="display: none;"></div>
                    </div>
                    <div class="adm_notifolder_vidget_submit">
                        <button class="xt_button xt_button_gray" data-cancel></button>
                        <button class="xt_button" data-confirm></button>
                    </div>
                </div>
            </dialog>
        `;

        document.body.insertAdjacentHTML('beforeend', modalHtml);
        const modal = document.getElementById(modalId);
        const field = modal.querySelector('[data-select-field]');
        const selector = modal.querySelector('[data-selector]');
        const itemsContainer = modal.querySelector('.adm_notifolder_vidget_selector_items');
        let selectedValue = null;

        modal.querySelector('.adm_notifolder_vidget_caption').textContent = options.title || '';
        selector.textContent = options.placeholder || 'Select...';
        modal.querySelector('.xt_button_gray').textContent = options.cancelText || 'Cancel';
        modal.querySelector('button[data-confirm]').textContent = options.confirmText || 'OK';

        // Items
        (options.items || []).forEach(item => {
            const p = document.createElement('p');
            p.dataset.value = item.value;
            p.dataset.selectItem = '';
            p.textContent = item.text;
            p.addEventListener('click', function () {
                selectedValue = this.dataset.value;
                selector.textContent = this.textContent;
                field.classList.remove('opened');
                itemsContainer.style.display = 'none';
            });
            itemsContainer.appendChild(p);
        });

        selector.addEventListener('click', () => {
            const isOpen = field.classList.toggle('opened');
            itemsContainer.style.display = isOpen ? 'block' : 'none';
        });

        const closeAndResolve = (value) => {
            if (typeof window.closeDialog === 'function') {
                window.closeDialog(modal);
                setTimeout(() => modal.remove(), 250);
            } else {
                modal.close();
                modal.remove();
            }
            resolve(value);
        };

        modal.querySelectorAll('[data-confirm]').forEach(el => {
            el.addEventListener('click', () => closeAndResolve(selectedValue));
        });
        modal.querySelectorAll('[data-cancel]').forEach(el => {
            el.addEventListener('click', () => closeAndResolve(null));
        });
        modal.addEventListener('close', () => {
            if (modal.parentNode) modal.remove();
            resolve(null);
        }, { once: true });

        if (typeof window.openDialog === 'function') {
            window.openDialog(modal);
        } else {
            modal.showModal();
        }
    });
};

window.showAdmConfirmation = function (message, options) {
    return new Promise((resolve) => {
        const modalId = 'adm-confirm-' + Date.now();
        const settings = Object.assign({ confirmText: 'Delete', cancelText: 'Cancel' }, options);

        const modalHtml = `
            <dialog id="${modalId}" class="adm_totypop_vidget adm_totypop_vidget_dialog"
                    data-close-on-backdrop="true" data-close-on-escape="true" data-backdrop="default">
                <span class="xt_close noselect" data-cancel></span>
                <div class="adm_totypop_vidget_wrap">
                    <div class="xt_text"></div>
                    <div class="xt_submit">
                        <button class="xt_button xt_button_gray" data-cancel></button>
                        <button class="xt_button" data-confirm></button>
                    </div>
                </div>
            </dialog>
        `;

        document.body.insertAdjacentHTML('beforeend', modalHtml);
        const modal = document.getElementById(modalId);
        modal.querySelector('.xt_text').textContent = message;
        modal.querySelector('.xt_button_gray').textContent = settings.cancelText;
        modal.querySelector('button[data-confirm]').textContent = settings.confirmText;

        const closeAndResolve = (value) => {
            if (typeof window.closeDialog === 'function') {
                window.closeDialog(modal);
                setTimeout(() => modal.remove(), 250);
            } else {
                modal.close();
                modal.remove();
            }
            resolve(value);
        };

        modal.querySelectorAll('[data-confirm]').forEach(el => {
            el.addEventListener('click', () => closeAndResolve(true));
        });
        modal.querySelectorAll('[data-cancel]').forEach(el => {
            el.addEventListener('click', () => closeAndResolve(false));
        });
        modal.addEventListener('close', () => {
            if (modal.parentNode) modal.remove();
            resolve(false);
        }, { once: true });

        if (typeof window.openDialog === 'function') {
            window.openDialog(modal);
        } else {
            modal.showModal();
        }
    });
};

window.showLargeModal = function (modalId) {
    const modal = document.getElementById(modalId);
    if (!modal) {
        console.error('Large modal not found:', modalId);
        return;
    }

    modal.style.display = 'flex';
    setTimeout(function () {
        modal.style.opacity = '1';
    }, 10);
    document.body.style.overflow = 'hidden';
    modal.dataset.largeModalActive = 'true';
};

window.closeLargeModal = function (modalId) {
    const modal = document.getElementById(modalId);
    if (!modal) return;

    modal.style.opacity = '0';
    setTimeout(function () {
        modal.style.display = 'none';
        document.body.style.overflow = '';
        delete modal.dataset.largeModalActive;
    }, 200);
};

// Глобальные обработчики для больших модалок
document.addEventListener('click', function (e) {
    if (e.target.classList.contains('adm_popup_overlay') &&
        e.target.classList.contains('adm_large_modal') &&
        e.target.dataset.largeModalActive === 'true') {
        window.closeLargeModal(e.target.id);
    }
});

document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
        const modal = document.querySelector('.adm_large_modal[data-large-modal-active="true"]');
        if (modal) {
            window.closeLargeModal(modal.id);
        }
    }
});
